module.exports = __webpack_public_path__ + "img/手淘旺旺示例图.0c92ee28.jpeg";